import { configureStore, Store } from "@reduxjs/toolkit";
import { useDispatch, useSelector } from "react-redux";

import resourcesReducer, { path as resourcesPath } from "@imminently/react/store/query";
import { reducer as notifications } from "@imminently/react/store/notifications";

import type { TypedUseSelectorHook } from "react-redux";
import patientList from "@/pages/home/patient-list/patient-slice";

export const store: Store = configureStore({
  reducer: {
    notifications,
    [resourcesPath]: resourcesReducer,
    patientList,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(),
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

// export const routerSelector = (s: RootState) => s.history;
export const notificationSelector = (s: RootState) => s.notifications;